<template>
  <v-data-table
    :headers="displayHeaders"
    :items="items"
    :rows-per-page-items="[10]"
    class="inline-edit"
    hide-actions
    item-key="idx"
  >
    <template slot="items" slot-scope="props">
      <td
        :class="{ 'text-xs-right': header.align === 'right' }"
        :key="header.col"
        class
        v-for="header in displayHeaders"
      >
        <span v-if="header.value === 'name'">{{ props.item.name }}</span>
        <span v-if="header.value === 'price'">{{
          props.item.price | currency
        }}</span>
        <span v-if="header.value === 'qty'">{{ props.item.qty }}</span>
        <span v-if="header.value === 'subTotal'">{{
          props.item.subTotal | currency
        }}</span>
        <span v-if="header.value === 'paymentSubTotal'">{{
          props.item.paymentSubTotal | currency
        }}</span>
        <span v-if="header.value === 'currencyCode'">{{
          props.item.currencyCode
        }}</span>
        <span v-if="header.value === 'currencyRate'">{{
          props.item.currencyRate
        }}</span>
        <span v-if="header.value === 'jpySubTotal'">{{
          props.item.jpySubTotal | currency({ fractionCount: 0 })
        }}</span>
        <span v-if="header.value === 'consumptionTaxName'">{{
          props.item.taxTypeName
        }}</span>
        <span v-if="header.value === 'jpySubTotalNoTax'">{{
          props.item.jpySubTotal | currency
        }}</span>
        <span v-if="header.value === 'jpyTaxTotal'">{{
          props.item.jpyTaxTotal | currency
        }}</span>
        <span v-if="header.value === 'paymentJpyTaxTotal'">{{
          props.item.paymentJpyTaxTotal | currency
        }}</span>
        <span v-if="header.value === 'comment'">{{ props.item.comment }}</span>
        <span v-if="header.value === 'supplierName'">{{
          props.item.supplierName
        }}</span>
        <span v-if="header.value === 'status'">{{ props.item.status }}</span>
        <span v-if="header.value === 'branchCode'">{{
          shipment.branchCode
        }}</span>
        <remote-autocomplete
          v-model="props.item.providerId"
          :rules="
            props.item.originalSubTotal ||
            props.item.subTotal ||
            props.item.paymentSubTotal
              ? [(v) => !!v || `諸掛請求先 is required`]
              : []
          "
          clearable
          placeholder="请输入諸掛請求先"
          url="overseas-providers/kv"
          v-if="header.value === 'providerId'"
        />
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    shipment: Object,
    scope: String,
    supplierId: String,
    columns: String,
    hideAdditionalCharges: Boolean,
  },
  data() {
    return {
      items: [],
      headers: [
        {
          text: '費用項目',
          value: 'name',
          sortable: false,
          col: '0',
        },
        {
          text: '金額',
          value: 'subTotal',
          width: '200px',
          sortable: false,
          align: 'right',
          col: '1',
        },
        {
          text: '通貨',
          value: 'currencyCode',
          width: '200px',
          sortable: false,
          col: '2',
        },
        {
          text: 'レート',
          value: 'currencyRate',
          width: '200px',
          sortable: false,
          align: 'right',
          col: '3',
        },
        {
          text: '換算金額',
          value: 'jpySubTotal',
          width: '200px',
          sortable: false,
          align: 'right',
          col: '4',
        },
        {
          text: '税区分',
          value: 'consumptionTaxName',
          width: '200px',
          sortable: false,
          col: '5',
        },
        {
          text: '円換算税抜金額',
          value: 'jpySubTotalNoTax',
          width: '200px',
          sortable: false,
          align: 'right',
          col: '6',
        },
        {
          text: '円換算税金金額',
          value: 'jpyTaxTotal',
          width: '200px',
          sortable: false,
          align: 'right',
          col: '7',
        },
        {
          text: 'コメント',
          width: '500px',
          value: 'comment',
          sortable: false,
          col: '8',
        },
        {
          text: '支払先',
          value: 'supplierName',
          width: '600px',
          sortable: false,
          col: '9',
        },
        {
          text: 'ステータス',
          value: 'status',
          width: '200px',
          sortable: false,
          col: '10',
        },
        {
          text: '金額',
          value: 'jpySubTotal',
          width: '200px',
          sortable: false,
          align: 'right',
          col: '11',
        },
        {
          text: '税金金額',
          value: 'jpyTaxTotal',
          width: '200px',
          sortable: false,
          align: 'right',
          col: '12',
        },
        {
          text: '単価',
          value: 'price',
          width: '200px',
          sortable: false,
          align: 'right',
          col: '13',
        },
        {
          text: '数量',
          value: 'qty',
          width: '200px',
          sortable: false,
          align: 'right',
          col: '14',
        },
        {
          text: '外貨小計',
          value: 'subTotal',
          width: '200px',
          sortable: false,
          align: 'right',
          col: '15',
        },
        {
          text: '税抜きJPY小計',
          value: 'jpySubTotalNoTax',
          width: '200px',
          sortable: false,
          align: 'right',
          col: '16',
        },
        {
          text: '税金JPY小計',
          value: 'jpyTaxTotal',
          width: '200px',
          sortable: false,
          align: 'right',
          col: '17',
        },
        {
          text: '計算費用項目',
          value: 'name',
          sortable: false,
          col: '18',
        },
        {
          text: '円価',
          value: 'jpySubTotal',
          sortable: false,
          align: 'right',
          col: '19',
        },
        {
          text: 'D/O枝番',
          value: 'branchCode',
          sortable: false,
          align: 'right',
          col: '20',
        },
        {
          text: '金額',
          value: 'paymentSubTotal',
          sortable: false,
          align: 'right',
          col: '21',
        },
        {
          text: '税金金額',
          value: 'paymentJpyTaxTotal',
          width: '200px',
          sortable: false,
          align: 'right',
          col: '22',
        },
        {
          text: '諸掛請求先',
          value: 'providerId',
          sortable: false,
          col: '23',
          width: 200,
        },
      ],
    }
  },
  hasCost(charge) {
    return charge.subTotal > 0 && charge.jpySubTotal > 0
  },
  mounted() {
    this.loadChargeItems()
  },

  computed: {
    displayHeaders() {
      if (this.columns) {
        return this.columns
          .split(',')
          .map((c) => this.headers.find((h) => h.col === c))
      } else {
        return this.headers
      }
    },
  },
  watch: {
    shipment() {
      this.loadChargeItems()
    },
    'shipment.transportModeId': function () {
      this.loadChargeItems()
    },
    'shipment.stackTypeId': function () {
      this.loadChargeItems()
    },
    'shipment.deliveryModelId': function () {
      this.loadChargeItems()
    },
    'shipment.incotermId': function () {
      this.loadChargeItems()
    },
  },
  methods: {
    getCharges() {
      return this.items
    },
    wantExtentContainer(item) {
      const list = [
        'SEA-001',
        'SEA-002',
        'SEA-003',
        'SEA-014',
        'SEA-015',
        'SEA-016',
      ]
      return list.indexOf(item.code) !== -1 && this.scope !== '3'
    },
    show(item) {
      return (
        (this.$isAir(this.shipment.transportModeId) &&
          this.$isAir(item.transportModeId)) ||
        (this.$isSea(this.shipment.transportModeId) &&
          this.$isSea(item.transportModeId) &&
          this.shipment.stackTypeId === 'STACK_TYPE-FCL' &&
          (!item.stackType || item.stackType === 'FCL')) ||
        (this.$isSea(this.shipment.transportModeId) &&
          this.$isSea(item.transportModeId) &&
          this.shipment.stackTypeId === 'STACK_TYPE-LCL' &&
          (!item.stackType || item.stackType === 'LCL')) ||
        (!item.transportModeId && !item.stackType)
      )
    },

    warehouseTransportFilter() {
      return (i) =>
        this.shipment.isAllUnpaidWarehouseTransport
          ? true
          : i.subTypeId !== 'CHARGE_ITEM_SUB_TYPE-WAREHOUSE_TRANSPORT'
    },

    loadChargeItems() {
      const list = [
        'CHARGE_ITEM_SUB_TYPE-CHARTER',
        'CHARGE_ITEM_SUB_TYPE-DRAKE',
        'CHARGE_ITEM_SUB_TYPE-MIX_LOADING',
      ]

      this.$http.get('/charge-items?size=1000&sort=seq,asc').then((res) => {
        this.items = res.data.content
          .filter((i) => i.scopes && i.scopes.indexOf(this.scope) !== -1)
          .filter((i) => !this.hideAdditionalCharges || !i.isAdditionalCharge)
          .filter(this.warehouseTransportFilter())
          .filter((i) => !i.isDestinationCharge)
          .filter((i) => this.show(i))
          .filter(
            (i) =>
              i.incoterms.find(
                (incoterm) => incoterm.id === this.shipment.incotermId
              ) || i.incoterms.length == 0
          )
          .filter(
            (i) =>
              list.indexOf(i.subTypeId) === -1 ||
              i.subTypeId === this.shipment.deliveryModelId
          )
          .reduce((t, i) => {
            if (this.wantExtentContainer(i)) {
              let name = i.name === 'FREIGHT' ? '' : i.name + ' '
              return [
                ...t,
                { ...i, containerTypeCode: '20F', name: name + '20F' },
                { ...i, containerTypeCode: '40F', name: name + '40F' },
                { ...i, containerTypeCode: '40FHQ', name: name + '40H' },
              ]
            } else {
              return [...t, i]
            }
          }, [])
          .map((i, idx) => {
            let charge = this.findCharge(i) || { supplierId: this.supplierId }
            return {
              ...i,
              ...charge,
              id: i.id,
              idx: new Date().getTime() + idx,
            }
          })
          .filter((i) => i.qty || i.subTotal)
          .sort((a, b) => parseInt(a.seq) - parseInt(b.seq))
      })
    },

    findCharge(item) {
      let charge =
        this.shipment &&
        this.shipment.charges &&
        this.shipment.charges.find(
          (c) =>
            c.chargeItemId === item.id &&
            (!item.containerTypeCode ||
              item.containerTypeCode === c.containerTypeCode)
        )
      return charge
    },
  },
}
</script>